<template>
  <!-- 保留通用弹窗的防遮挡布局，勾选模板再叠加独立的授权样式。 -->
  <van-popup
    v-model="incomingShow"
    class="agreement-popup"
    :class="{ 'agreement-consent': requireConsent }"
    round
    position="bottom"
    :safe-area-inset-bottom="true"
    :close-on-click-overlay="false"
    @opened="handlePopupOpened"
    :style="{ height: '90%' }"
  >
    <van-icon class="closeBtn" name="cross" size="0.45rem" @click="onClickCloseIcon" />
    <div class="show-con">
      <p class="pup-title">
        <span v-if="isShowTitle">
          <span>我们</span>
          将根据您的资质，为您匹配专业的贷款咨询服务公司（包含：
          <small>{{ companys }}</small>
          ）
        </span>
      </p>
      <!-- 撞库成功或失败后匹配到 CPA 产品时披露匹配结果，无有效产品时不展示卡片。 -->
      <section v-if="matchedProduct" class="match-product-card">
        <div class="match-product-card__header">
          <div class="match-product-card__heading">
            <h3>{{ matchedProduct.productName }}</h3>
            <p>已为您匹配合适的借款产品</p>
          </div>
          <span class="match-product-card__badge">匹配成功</span>
        </div>
        <div
          v-if="matchedProduct.companyName || matchedProduct.annualRate"
          class="match-product-card__body"
        >
          <div v-if="matchedProduct.companyName" class="match-product-card__row">
            <span>信息服务机构</span>
            <strong>{{ matchedProduct.companyName }}</strong>
          </div>
          <div
            v-if="matchedProduct.annualRate"
            class="match-product-card__row match-product-card__row--rate"
          >
            <span>
              年化利率
              <small>（单利，已包含全部息费）</small>
            </span>
            <strong>{{ matchedProduct.annualRate }}</strong>
          </div>
        </div>
        <div v-if="matchedProduct.riskTip" class="match-product-card__risk">
          <van-icon name="warning-o" />
          <span>{{ matchedProduct.riskTip }}</span>
        </div>
      </section>
      <div
        ref="protocolContainer"
        class="pup-protocol u-text-center"
        :class="{ 'is-single': isSingleAgreement }"
      >
        <!-- 默认机构 -->
        <div
          v-for="(item, index) in defaultAgreements"
          :key="index + 'default'"
          :ref="'protocol-default-' + index"
          class="pr"
          :class="item.flag ? '' : 'expand-height'"
        >
          <div class="pr-html">
            <h4>{{ item.contractName }}</h4>
            <div
              class="protocol-content"
              v-html="handleDynamicData(item.contractContent, userDynamicData)"
            ></div>
            <van-cell
              v-if="item.flag"
              class="pa islink"
              :border="false"
              :clickable="true"
              @click="
                () => {
                  item.flag = false
                }
              "
            >
              <template #default>
                <span>完整协议</span>
                <!-- <van-icon name="arrow-double-right" /> -->
                <!-- <van-icon name="arrow" /> -->
                <svg
                  t="1775627117872"
                  class="icon arrow-double-right"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="4863"
                >
                  <path
                    d="M540.657778 744.448a35.555556 35.555556 0 0 1-50.062222 0.661333L294.513778 555.790222a21.333333 21.333333 0 0 1 29.639111-30.698666l191.011555 184.433777 187.847112-191.146666a21.333333 21.333333 0 0 1 30.428444 29.902222l-192.782222 196.167111z"
                    fill="#666666"
                    p-id="4864"
                  ></path>
                  <path
                    d="M540.657778 495.559111a35.555556 35.555556 0 0 1-50.062222 0.661333L294.513778 306.901333a21.333333 21.333333 0 0 1 29.639111-30.691555l191.011555 184.426666 187.847112-191.146666a21.333333 21.333333 0 0 1 30.428444 29.902222L540.657778 495.559111z"
                    fill="#999999"
                    p-id="4865"
                  ></path>
                </svg>
              </template>
            </van-cell>
          </div>
        </div>
        <!-- 三方机构 -->
        <p
          v-if="thirdAgreements.length && (thirdAgreementProductName || thirdAgreementCompanyName)"
          style="font-size: 17px; margin-bottom: 10px; font-weight: 700"
        >
          <span v-if="thirdAgreementProductName && thirdAgreementCompanyName"
            >{{ thirdAgreementCompanyName }}--{{ thirdAgreementProductName }}</span
          >
          <span v-else-if="thirdAgreementProductName">{{ thirdAgreementProductName }}</span>
          <span v-else-if="thirdAgreementCompanyName">{{ thirdAgreementCompanyName }}</span>
        </p>
        <div
          v-for="(item, index) in thirdAgreements"
          :key="index + 'third'"
          :ref="'protocol-third-' + index"
          class="pr"
          :class="item.flag ? '' : 'expand-height'"
        >
          <div class="pr-url" v-if="item.contractUrl && item.contractUrl != ''">
            <ThirdAgreement :thirdUrl="item.contractUrl" />
          </div>
          <div v-else class="pr-html">
            <h4>《{{ item.contractName }}》</h4>
            <div
              class="protocol-content"
              v-html="handleDynamicData(item.contractContent, userDynamicData)"
            ></div>
            <van-cell
              v-if="item.flag"
              class="pa islink"
              :border="false"
              :clickable="true"
              @click="
                () => {
                  item.flag = false
                }
              "
            >
              <template #default>
                <span>完整协议</span>
                <svg
                  t="1775627117872"
                  class="icon arrow-double-right"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="4863"
                >
                  <path
                    d="M540.657778 744.448a35.555556 35.555556 0 0 1-50.062222 0.661333L294.513778 555.790222a21.333333 21.333333 0 0 1 29.639111-30.698666l191.011555 184.433777 187.847112-191.146666a21.333333 21.333333 0 0 1 30.428444 29.902222l-192.782222 196.167111z"
                    fill="#666666"
                    p-id="4864"
                  ></path>
                  <path
                    d="M540.657778 495.559111a35.555556 35.555556 0 0 1-50.062222 0.661333L294.513778 306.901333a21.333333 21.333333 0 0 1 29.639111-30.691555l191.011555 184.426666 187.847112-191.146666a21.333333 21.333333 0 0 1 30.428444 29.902222L540.657778 495.559111z"
                    fill="#999999"
                    p-id="4865"
                  ></path>
                </svg>
              </template>
            </van-cell>
          </div>
        </div>
      </div>
    </div>
    <div class="go-on u-text-center">
      <!-- 新模板在继续进件前单独确认本次产品协议，不沿用表单页的勾选状态。 -->
      <van-checkbox
        v-if="requireConsent"
        v-model="consentChecked"
        checked-color="#ff5612"
        icon-size="0.28rem"
        class="consent-checkbox"
      >
        我已阅读并同意
        <span
          v-for="link in agreementLinks"
          :key="link.key"
          class="consent-link"
          role="button"
          tabindex="0"
          @click.stop="openAgreement(link)"
          @keydown.enter.stop.prevent="openAgreement(link)"
          >《{{ link.item.contractName }}》</span
        >
      </van-checkbox>
      <!-- 协议确认改为用户主动点击，不再由倒计时自动触发。 -->
      <p @click="handleGoOn">我已知晓</p>
    </div>
    <van-popup
      v-if="requireConsent"
      v-model="consentPromptShow"
      get-container="body"
      class="consent-prompt"
      :close-on-click-overlay="false"
      :style="{ width: '85%' }"
      round
      closeable
    >
      <h3>服务协议及授权协议</h3>
      <div class="consent-prompt__protocols">
        我已阅读并同意
        <span
          v-for="link in agreementLinks"
          :key="link.key"
          class="consent-link"
          role="button"
          tabindex="0"
          @click.stop="openAgreement(link)"
          @keydown.enter.stop.prevent="openAgreement(link)"
          >《{{ link.item.contractName }}》</span
        >
      </div>
      <van-button block color="#ff5612" round @click="handleConsentAgree"> 同意并继续 </van-button>
      <p class="consent-prompt__disagree" @click="consentPromptShow = false">不同意</p>
    </van-popup>
  </van-popup>
</template>

<script>
import ThirdAgreement from './thirdAgree.vue'
import { replaceTemplateValues } from '@/utils/replaceTemplateValues.js'
export default {
  name: 'Agreement',
  components: {
    ThirdAgreement,
  },
  props: {
    // 默认关闭，只有“进件闪借花-勾选协议”模板启用二次协议确认。
    requireConsent: {
      type: Boolean,
      default: false,
    },
    matchSuccess: {
      type: Boolean,
      default: false,
    },
    submitting: {
      type: Boolean,
      default: false,
    },
    incomingShow: {
      type: Boolean,
      default: false,
    },
    sendData: {
      type: Object,
    },
    form: {
      type: Object,
    },
    applyTime: {
      type: String,
    },
    companys: {
      // 公司名称集合
      type: String,
    },
    companyAlias: {
      // 公司别名
      type: String,
    },
    productId: {
      // 产品id
    },
    applyId: {
      // 进件申请ID
    },
    protocolDynamicData: {
      type: Object,
    },
  },
  data() {
    return {
      thirdAgreementProductName: null, //第三方产品名称
      thirdAgreementCompanyName: null, //第三方公司名称
      //三方机构
      thirdAgreements: [],
      //默认机构
      defaultAgreements: [],
      consentChecked: false,
      consentPromptShow: false,
      consentSubmitted: false,
    }
  },
  watch: {
    sendData: {
      handler(val, oldVal) {
        // 原模板仍仅响应整个回包替换；新模板在协议内容变化时也撤销原授权。
        if (!this.requireConsent && val === oldVal) return
        this.institutionHandle(val?.agreements)
        if (this.requireConsent) this.resetConsent()
      },
      deep: true,
    },
    incomingShow(show) {
      if (!this.requireConsent) return
      this.resetConsent()
      if (show) this.institutionHandle(this.sendData?.agreements)
    },
    productId() {
      if (this.requireConsent) this.resetConsent()
    },
    submitting(val) {
      // 请求失败回到可操作态时允许重试，避免一次确认后按钮永久失效。
      if (!val) this.consentSubmitted = false
    },
    protocolDynamicData: {
      handler(val) {
        console.log('协议动态值user接口', val)
      },
      deep: true, // 深度监听
      immediate: true, // 立即触发一次
    },
  },
  computed: {
    matchedProduct() {
      const data = this.sendData || {}
      // 普通模板读取统一补齐的 CPA 匹配状态，勾选模板沿用进件页已确认的状态。
      const matched = this.requireConsent ? this.matchSuccess : Number(data.hasPushSuccess) === 1
      if (!matched) return null

      // 接口字段均为可选，成功时保留产品标题并按字段是否返回决定明细行展示。
      return {
        productName: data.productName || '借款产品',
        companyName: data.companyName || '',
        annualRate: data.annualRate || '',
        riskTip: data.riskTip || '',
      }
    },
    isShowTitle() {
      return this.companys && this.companys !== ''
    },
    userDynamicData() {
      return {
        ...this.protocolDynamicData,
        productName: this.sendData?.agreements?.thirdAgreement?.productName || '',
        companyName: this.sendData?.agreements?.thirdAgreement?.companyName || '',
      }
    },
    // 协议总条数（默认机构 + 三方机构）
    agreementCount() {
      return this.defaultAgreements.length + this.thirdAgreements.length
    },
    agreementLinks() {
      return [
        ...this.defaultAgreements.map((item, index) => ({
          key: 'default-' + index,
          item,
        })),
        ...this.thirdAgreements.map((item, index) => ({
          key: 'third-' + index,
          item,
        })),
      ]
    },
    // 仅一条协议时，协议列表区域随内容收缩高度
    isSingleAgreement() {
      return this.agreementCount === 1
    },
  },
  methods: {
    onClickCloseIcon() {
      this.$emit('update:incomingShow', false)
    },
    handleDynamicData(content, data) {
      let replacements = {
        ...data,
        username: data.realName ? data.realName : '',
        phone: data.mobile ? data.mobile : '',
      }
      let xxsqProtocol = replaceTemplateValues(content, replacements)
      return xxsqProtocol
    },
    institutionHandle(data) {
      // 换品后若不再返回平台协议，新模板必须移除旧协议名称和内容。
      if (this.requireConsent) this.defaultAgreements = []
      if (data?.defaultAgreements) {
        this.defaultInstitutionHandle(data.defaultAgreements)
      }
      if (data?.thirdAgreement) {
        this.thirdInstitutionHandle(data.thirdAgreement)
      } else {
        this.thirdAgreements = []
        this.thirdAgreementProductName = null
        this.thirdAgreementCompanyName = null
      }
    },
    //默认机构数据处理
    defaultInstitutionHandle(defaultData) {
      if (!defaultData) return
      this.defaultAgreements = []
      defaultData.forEach((item) => {
        const newItem = { ...item } // 浅拷贝item，避免直接修改原数组
        newItem.flag = true
        this.defaultAgreements.push(newItem)
      })
    },
    //第三方机构数据处理
    thirdInstitutionHandle(thirdData) {
      if (!thirdData) return
      this.thirdAgreements = []
      this.thirdAgreementProductName = thirdData.productName
      this.thirdAgreementCompanyName = thirdData.companyName
      thirdData.agreements.forEach((item) => {
        const newItem = { ...item } // 浅拷贝item，避免直接修改原数组
        newItem.flag = true
        this.thirdAgreements.push(newItem)
      })
    },
    handlePopupOpened() {
      this.$emit('popupOpened')
    },
    resetConsent() {
      this.consentChecked = false
      this.consentPromptShow = false
      this.consentSubmitted = false
    },
    openAgreement(link) {
      this.consentPromptShow = false
      link.item.flag = false
      // 在原协议块定位，HTML 与第三方 iframe 沿用各自现有渲染方式。
      this.$nextTick(() => {
        const container = this.$refs.protocolContainer
        const blocks = this.$refs['protocol-' + link.key]
        const block = Array.isArray(blocks) ? blocks[0] : blocks
        if (!container || !block) return
        container.scrollTop +=
          block.getBoundingClientRect().top - container.getBoundingClientRect().top
      })
    },
    handleConsentAgree() {
      this.consentPromptShow = false
      this.consentChecked = true
      this.handleGoOn()
    },
    handleGoOn() {
      if (this.requireConsent) {
        if (this.consentSubmitted || this.submitting) return
        if (!this.consentChecked) {
          this.consentPromptShow = true
          return
        }
        // 所有继续事件统一放在授权之后，覆盖普通推送及半流程直跳，并防止重复放行。
        this.consentSubmitted = true
      }
      this.$emit('knowClicked')
      this.$emit('clearApplyId')
      this.$emit('handleGoOn')
    },
  },
}
</script>

<style lang="scss" scoped>
.agreement-popup {
  // 按钮单独占据底部空间，协议只在剩余高度内滚动，避免被按钮覆盖。
  display: flex;
  flex-direction: column;
}

.container {
  padding-bottom: 0.1rem;

  .container-top {
    padding: 0.4rem 0.3rem 0;

    > div {
      padding: 0.3rem;
      background: #f6f8ff;
      font-size: 0.24rem;
      border-radius: 0.24rem;
      font-family: PingFangSC, PingFangSC-Regular;
      font-weight: normal;
      color: #868e9e;

      img {
        width: 0.4rem;
        height: 0.4rem;
        margin-right: 0.16rem;
      }

      .container-top-title {
        font-size: 0.28rem;
        font-family: PingFangSC, PingFangSC-Medium;
        font-weight: normal;
        color: #111c31;
        margin-bottom: 0.02rem;
      }

      .container-top-amount {
        font-size: 0.4rem;
        font-family: Helvetica, Helvetica-Helvetica;
        font-weight: normal;
        color: #111c31;
      }
    }
  }

  .register-form {
    background: #ffffff;
    border-radius: 0.16rem;
    padding: 0.4rem 0.3rem 0.3rem;
  }

  .register-form-item {
    margin-bottom: 0.15rem;
    border-bottom: 0.02rem solid #f1f2f6;
    padding: 0.02rem 0;

    &.mb0 {
      margin-bottom: 0;
    }

    .inp-elem {
      padding: 0.2rem 0;
    }

    > h4 {
      font-size: 0.28rem;
      font-family: PingFangSC, PingFangSC-Regular;
      font-weight: 400;
      color: #111c31;
    }

    ::v-deep {
      .van-field__label {
        font-size: 0.28rem;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        color: #111c31;
      }

      .van-field__control {
        color: #868e9e;
        font-size: 0.28rem;
      }

      .van-field__button {
        color: #3563fa;
      }
    }

    small {
      font-size: 0.24rem;
      font-family: PingFangSC, PingFangSC-Regular;
      color: #868e9e;
      display: block;
      padding-bottom: 0.1rem;
    }

    .citys-tips {
      margin: 0.1rem 0 0.2rem;
      font-size: 0.24rem;
      font-family: PingFangSC, PingFangSC-Regular;
      font-weight: normal;
      color: #868e9e;
    }
  }

  .border-none {
    border: none;
  }

  .van-hairline--top-bottom::after {
    display: none;
  }

  .tags {
    font-size: 0.28rem;
    color: #868e9e;
  }

  .van-col {
    > div {
      height: 0.6rem;
      width: 100%;
      margin-top: 0.1rem;
      background: #ffff;
      border: 0.02rem solid #f1f2f6;
      border-radius: 0.12rem;
    }

    > div.mt0 {
      margin-top: 0;
    }
  }

  .tags .active {
    > div {
      background: rgba(53, 99, 250, 0.1);
      border-color: #3563fa;
      color: #3563fa;
    }
  }

  .btn-con {
    background: #fff;
    padding: 0 0.3rem;
    position: sticky;
    bottom: 0;
  }

  .btn {
    width: 100%;
    background: #3563fa;
    border-radius: 0.48rem;
    border: 0;
    font-family: PingFangSC, PingFangSC-Medium;
    font-size: 0.32rem;
    font-weight: 500;
    color: #fff;
    height: 0.96rem;
    line-height: 0.96rem;
    vertical-align: bottom;
    margin: 0.24rem 0 0.3rem;
  }

  .btn-tips {
    left: 47%;
    bottom: 70%;
    height: 0.44rem;
    line-height: 0.44rem;
    padding: 0 0.18rem;
    background: #f44138;
    border-radius: 0.22rem 0.22rem 0.22rem 0;
    font-size: 0.22rem;
    font-family: PingFangSC, PingFangSC-Regular;
    color: #ffffff;
  }

  .protocols {
    padding: 0 0.3rem;
    font-size: 0.24rem;

    ::v-deep .van-checkbox__icon {
      margin-top: 0.05rem;
    }
  }

  .protocols-title {
    color: #3563fa;
  }

  .tel-con {
    margin-top: 0.36rem;
    font-size: 0.22rem;
    font-family: PingFangSC, PingFangSC-Regular;
    font-weight: normal;
    color: #868e9e;

    > a {
      color: #3563fa;
    }
  }

  .bottom {
    margin: 0.24rem auto;
    font-family: PingFangSC, PingFangSC-Regular;
    font-size: 0.22rem;
    text-align: center;
    color: #c3c2c6;
    line-height: 0.36rem;
    white-space: pre-line;
  }

  .show-con {
    padding: 0 0.4rem;
    flex: 1;
    min-height: 0;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }

  .closeBtn {
    position: absolute;
    right: 0.3rem;
    top: 0.15rem;
    color: #868e9e;
    font-size: 0.4rem;
  }

  .pup-title {
    margin: 0.7rem 0 0.24rem;
    font-size: 0.24rem;
    font-family: PingFangSC, PingFangSC-Regular;
    font-weight: 400;
    color: #868e9e;
    text-align: justify;
    flex-shrink: 0;
  }

  .match-product-card {
    flex-shrink: 0;
    margin-bottom: 0.28rem;
    padding: 0.28rem;
    text-align: left;
    background: linear-gradient(145deg, #fffaf7 0%, #ffffff 68%);
    border: 0.02rem solid #ffd8c6;
    border-radius: 0.28rem;
    box-shadow: 0 0.1rem 0.3rem rgba(238, 102, 45, 0.09);

    &__header {
      display: flex;
      align-items: center;
      padding-bottom: 0.22rem;
      border-bottom: 0.02rem solid #f8e8e0;
    }

    &__heading {
      min-width: 0;
      flex: 1;

      h3 {
        margin: 0 0 0.04rem;
        color: #33241e;
        font-size: 0.3rem;
        line-height: 0.42rem;
      }

      p {
        margin: 0;
        color: #a28b81;
        font-size: 0.2rem;
        line-height: 0.3rem;
      }
    }

    &__badge {
      padding: 0.07rem 0.14rem;
      color: #f46327;
      font-size: 0.2rem;
      line-height: 0.28rem;
      background: #fff0e8;
      border-radius: 0.2rem;
    }

    &__body {
      padding: 0.14rem 0 0.08rem;
    }

    &__row {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 0.24rem;
      min-height: 0.58rem;
      color: #83746d;
      font-size: 0.23rem;

      > span {
        flex-shrink: 0;
      }

      strong {
        color: #40342f;
        font-size: 0.24rem;
        font-weight: 500;
        text-align: right;
      }

      small {
        display: block;
        margin-top: 0.02rem;
        color: #b2a39c;
        font-size: 0.18rem;
      }

      &--rate strong {
        color: #ff5612;
        font-size: 0.3rem;
        font-weight: 600;
      }
    }

    &__risk {
      display: flex;
      align-items: flex-start;
      gap: 0.1rem;
      padding: 0.16rem 0.18rem;
      color: #9b6a55;
      font-size: 0.2rem;
      line-height: 0.32rem;
      background: #fff3ed;
      border-radius: 0.16rem;

      .van-icon {
        flex-shrink: 0;
        margin-top: 0.05rem;
        color: #ff6b2c;
        font-size: 0.24rem;
      }
    }
  }

  .pup-protocol {
    min-height: 0;
    flex: 1;
    overflow: auto;

    // 单份协议也受剩余高度约束，长内容可滚动到按钮上方。
    &.is-single {
      height: auto;
      max-height: 100%;
      flex: 1;
    }

    > div.pr {
      height: 300px;
      background: #f5f5f5;
      border-radius: 12px;
      border: 1px solid #dcdcdc;
      padding: 0.26rem;
      margin-bottom: 0.5rem;
      overflow: hidden;
      transition: height 1s linear;

      .pr-html {
        height: 100%;
        // overflow: hidden;
      }

      .pr-url {
        height: 100%;
      }
    }

    > div.expand-height {
      height: auto;
    }

    h4 {
      margin-bottom: 0.2rem;
      font-size: 0.3rem;
      font-family: PingFangSC, PingFangSC-Medium;
      font-weight: 600;
      color: #3c3e41;
    }

    .islink {
      padding: 0.05rem;
      right: 0;
      bottom: 0;
      width: 100%;
      // background: #ffffff;
      border-radius: 8px;
      // box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
      height: 40px;
      line-height: 40px;
      font-size: 0.24rem;
      text-align: center;
      font-weight: 500;
      color: #666666;
      background: linear-gradient(
        to bottom,
        rgba(255, 255, 255, 0) 0%,
        rgba(255, 255, 255, 0.95) 20%,
        #ffffff 100%
      );
      padding-top: 0.1rem;
      .van-cell__value {
        text-align: center;
        line-height: 40px;
        font-size: 0.24rem;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .arrow-double-right {
        width: 0.3rem;
        height: 0.3rem;
        margin-left: 0.1rem;
      }
    }
  }

  .go-on {
    flex-shrink: 0;
    background: #ffffff;
    box-shadow: 0px -0.04rem 0.2rem 0 rgba(0, 0, 0, 0.13);
    padding: 0.25rem 0.4rem 0.48rem;
    font-size: 0.32rem;
    font-family: PingFangSC, PingFangSC-Medium;
    font-weight: 500;
    color: #ffffff;

    > p {
      line-height: 0.96rem;
      background: linear-gradient(313deg, #ff5612 0%, #fd7539 100%);
      box-shadow: 0px 4px 10px 2px rgba(255, 136, 88, 0.28);
      border-radius: 0.54rem;
    }
  }

  .show-protocol-con {
    height: 100%;
    padding: 0.4rem 0.4rem 0;

    > h4 {
      margin-bottom: 0.2rem;
      font-size: 0.3rem;
      font-family: PingFangSC, PingFangSC-Medium;
      font-weight: 600;
      color: #3c3e41;
    }
  }

  .show-protocol-info {
    height: calc(100% - 1.45rem);
    overflow: auto;
  }

  .show-protocol-btn {
    left: 0;
    right: 0;
    border-top: 0.02rem solid #e3e3e3;
    font-size: 0.3rem;
    height: 0.8rem;
    line-height: 0.8rem;
    margin: 0 -0.4rem;
    font-family: PingFangSC, PingFangSC-Regular;
  }

  .picker-title {
    font-size: 0.32rem;

    p.pa {
      left: 0;
      top: 0.88rem;
      font-size: 0.24rem;
      font-family: PingFangSC, PingFangSC-Regular;
      font-weight: normal;
      color: #f44138;
      z-index: 2;
      padding: 0 0.25rem;
      text-align: left;
      background: #fff;
    }
  }
}

.agreement-consent {
  display: flex;
  flex-direction: column;

  // 底部确认区参与布局，长协议和多行协议名称不会被按钮遮住。
  .show-con {
    flex: 1;
    min-height: 0;
    height: auto;
  }

  .pup-protocol.is-single {
    flex: 1;
  }

  .go-on {
    position: static;
    flex-shrink: 0;
    height: auto;
    padding: 0.2rem 0.4rem 0.32rem;
  }

  .consent-checkbox {
    margin-bottom: 0.2rem;
    color: #3c3e41;
    font-size: 0.22rem;
    line-height: 0.34rem;
    text-align: left;
    align-items: flex-start;

    ::v-deep .van-checkbox__icon {
      margin-top: 0.03rem;
    }
  }
}

.consent-link {
  // 协议名换行时保持完整点击区域，避免点击行间空隙误触外层勾选框。
  display: inline-block;
  max-width: 100%;
  vertical-align: top;
  color: #1989fa;
  cursor: pointer;
}

.consent-prompt {
  padding: 0.5rem 0.4rem 0.3rem;
  color: #3c3e41;
  text-align: center;

  h3 {
    font-size: 0.32rem;
  }

  &__protocols {
    max-height: 40vh;
    overflow-y: auto;
    margin: 0.3rem 0;
    font-size: 0.26rem;
    line-height: 0.42rem;
    text-align: left;
  }

  &__disagree {
    margin-top: 0.25rem;
    color: #999;
    font-size: 0.26rem;
  }
}
</style>
